<template>
  <div>
    <v-btn :text="text" :variant="variant" :color="color" :prepend-icon="icon" :loading="loading" @click="logout" />
  </div>
</template>

<script>

export default {
  name: 'LogoutButton',
  data() {
    return {
      text: 'Logout',
      variant: 'text',
      color: '',
      icon: 'mdi-logout',
      loading: false,
    }
  },
  methods: {
    logout() {
      this.loading = true;

      this.$auth0.logout({ logoutParams: { returnTo: window.location.origin } });
    }
  },
};
</script>